import { useState } from "react";
import { API_URL } from "../../../config/api"; 

export default function PropertyGallery({ images, projectName }) {
    let parsedImages = [];

    try {
        if (typeof images === "string") {
            // Nếu string là JSON (bắt đầu bằng [), parse
            if (images.trim().startsWith("[")) {
                const parsed = JSON.parse(images);
                if (Array.isArray(parsed)) parsedImages = parsed;
            } else {
                // Nếu chỉ là 1 path string, đưa vào mảng
                parsedImages = [images];
            }
        } else if (Array.isArray(images)) {
            parsedImages = images;
        }
    } catch (error) {
        console.error("Lỗi parse images:", error);
    }

    const fullImageUrls = parsedImages.map((img) =>
        img.startsWith("http") ? img : `${API_URL}${img}`
    );

    const [selectedImage, setSelectedImage] = useState(fullImageUrls[0] || null);

    if (!fullImageUrls.length) return null; // Không có ảnh thì không render gì

    return (
        <>
            {selectedImage && (
                <img
                    loading="lazy"
                    src={selectedImage}
                    alt={projectName}
                    className="w-full h-auto rounded-xl"
                />
            )}
            <div className="flex mt-4 gap-2 overflow-x-auto">
                {fullImageUrls.map((img, idx) => (
                    <img
                        key={idx}
                        src={img}
                        alt={`Thumbnail ${idx}`}
                        onClick={() => setSelectedImage(img)}
                        className={`w-24 h-16 object-cover border rounded cursor-pointer transition 
                        ${img === selectedImage ? "ring-2 ring-blue-500" : ""}`}
                        loading="lazy"
                    />
                ))}
            </div>
        </>
    );
}
